import React, { useState, useEffect, } from 'react';
import 'font-awesome/css/font-awesome.min.css';
import '../../assets/stylesheet/layout.scss';
import Button from 'react-bootstrap/Button';
import SearchableSelect from '../../components/searchableSelect';
import DateRangePickerComponent from '../../components/date-range';
import '../../assets/stylesheet/insights.scss'
import DashedCircleProgressBar from '../../components/dashedcircleprogressbar';
import ReactPaginate from 'react-paginate';
import Autocomplete from '../../components/autocomplete';
import Form from 'react-bootstrap/Form';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import baseUrl from '../../services/baseUrl';
import ApiRequest from '../../services/apiService';
import GetTimeDifference from '../../utilities/getDateDifference';
import GetUserData from '../../utilities/getUserDetails';
import MyMultiSelectDropdown from "../../utilities/multiSelectInputType";
import SingleSelectSobDropDown from '../Dashboard/DropDownSelectSobInputType';
import SingleSelectTouchpointDropdown from '../Dashboard/DropDownSelectTouchpointInputType';
import '../../assets/stylesheet/multiSelectInputType.css';
import ScreenLoader from '../../components/screenLoader';

function LiveFeeds() {
    const [quickFilter, setQuickFilter] = useState(localStorage.getItem('quickFilter') || '');
    const [projects, setProjects] = useState([]);
    const [touchpointFilter, setTouchpointFilter] = useState(localStorage.getItem('touchpointFilter') || '');
    const [sobFilter, setSobFilter] = useState(localStorage.getItem('sobFilter') || '');
    const [feedsData, setFeedsData] = useState([]);
    const [projectFilter, setProjectFilter] = useState(localStorage.getItem('projectFilter') || "");
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [sortByOption, setSortByOption] = useState('');
    const [searchSelectFilter, setSearchSelectFilter] = useState('');
    const [selectedFilters, setSelectedFilters] = useState([]);
    const location = useLocation();
    const [noDataScreen, setNoDataScreen] = useState(false);
    const [IsLoading, setIsLoading] = useState(false);
    const [isAllTouchPoints, setIsAllTouchpoints] = useState(
        (localStorage.getItem('touchpointFilter') || localStorage.getItem('isAllTouchpoints')) ? true : false
    );
    const navigate = useNavigate();
    const [filterSearchTerm, setFilterSearchTerm] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredTerm, setFilteredTerm] = useState('');
    const [showFilters, setShowFilters] = useState('');
    const userData = GetUserData();

    const fetchData = async () => {
        setIsLoading(true);
        setNoDataScreen(false);
        try {
            const filterValues = {
                Promoters: 10,
                Passives: 8,
                Detractors: 6,
            };
            const PpdFiltersQuery = selectedFilters
                .map((filter) => filterValues[filter])
                .filter((value) => value !== undefined)
                .join(",");
            const params = new URLSearchParams({
                quickFilterRange: quickFilter,
                fromDate: localStorage.getItem('fromDate') || fromDate,
                toDate: localStorage.getItem('toDate') || toDate,
                projectFilter: projectFilter,
                ppdFilter: PpdFiltersQuery,
                sortByFilter: sortByOption,
                userCode: userData.UserCode,
                userRole: userData.UserRole,
                userEmail: userData.UserEmail,
                touchpointFilter: touchpointFilter,
                sobFilter: sobFilter,
                showFilter: showFilters
            });
            if (searchSelectFilter === 'Phone Number') {
                params.set('phoneNumber', filteredTerm);
            } else if (searchSelectFilter === 'Lab Number') {
                params.set('labNumber', filteredTerm);
            } else if (searchSelectFilter === 'Customer Name') {
                params.set('customerName', filteredTerm);
            }
            const url = `${baseUrl()}/nps/GetLiveFeedsData?${params.toString()}`;
            const response = await ApiRequest({ apiLink: url, method: 'GET' });
            if (response.Data.FeedsDataList && response.Message === 'Success') {
                setIsLoading(false);
                setProjects(response.Data.Projects);
                setFeedsData(response.Data.FeedsDataList);
            } else {
                setNoDataScreen(true);
                console.log('Failed to load data');
            }
        } catch (error) {
            console.error('Error fetching cloud data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [quickFilter, projectFilter, fromDate, toDate, selectedFilters,
        filteredTerm, sortByOption, touchpointFilter, sobFilter, showFilters]);

    const handleDateRangeFilter = (startDate, endDate) => {
        if (startDate && endDate) {
            setFromDate(startDate.toISOString().split("T")[0]);
            setToDate(endDate.toISOString().split("T")[0]);
            setQuickFilter("");
        } else {
            setFromDate("");
            setToDate("");
        }
        localStorage.setItem('quickFilter', '');
        localStorage.setItem('fromDate', startDate.toISOString().split("T")[0]);
        localStorage.setItem('toDate', endDate.toISOString().split("T")[0]);
        // window.location.reload();
    };
    //QuickFilters
    const handleQuickFilter = async (event) => {
        const selectedValue = event.target.value;
        setFromDate('');
        setToDate('');
        setQuickFilter(selectedValue);
        localStorage.setItem('fromDate', '');
        localStorage.setItem('toDate', '');
        localStorage.setItem('quickFilter', selectedValue);
        window.location.reload();
    };

    const categoryColors = {
        6: "#f10000",
        10: "#008000",
        8: "#ffb62f"
    };

    const categoryScore = {
        6: 60,
        10: 100,
        8: 80
    };

    const handleFilterClick = (type) => {
        setSelectedFilters(prevFilters => {
            if (!Array.isArray(prevFilters)) {
                console.error("prevFilters is not an array:", prevFilters);
                return [type];
            }

            const newFilters = prevFilters.includes(type)
                ? prevFilters.filter(filter => filter !== type)
                : [...prevFilters, type];

            return newFilters;
        });
    };
    
const CryptoJS = require('crypto-js');
const secretKey = 'your-secret-key'; // Replace with your own secret key

const handleFeedsTrClick = async (id, userName) => {
    if (userName && id) {
        const encryptedUserId = CryptoJS.AES.encrypt(id.toString(), secretKey).toString();
        const encodedUserId = encodeURIComponent(encryptedUserId);
        const query = `tempid=${encodedUserId}`;
        navigate(`/ConversationPreview?${query}`);
    } else {
        console.log('User not available');
    }
};


    const issueoptions = [
        { label: 'All Issue', value: 'All Issue' },
        { label: 'Assigned to me', value: 'Assigned to me' },
        { label: 'Followed by me', value: 'Followed by me' }
    ];

    const filteroptions = [
        { label: 'Customer Name', value: 'Customer Name' },
        { label: 'Phone Number', value: 'Phone Number' },
        { label: 'Lab Number', value: 'Lab Number' }
    ];
    const filterDate = [
        { label: 'By response date newest first', value: 'DESC' },
        { label: 'By response date oldest first', value: 'ASC' },
    ];
    const statusData = [
        { label: 'Open', value: 'Open' },
        { label: 'In-Progress', value: 'In-Progress' },
        { label: 'On-hold', value: 'On-hold' },
        { label: 'Closed', value: 'Closed' },
        { label: 'Unassigned', value: 'Unassigned' },
        { label: 'Assigned', value: 'Assigned' },
    ];



    const handleSelect = (option) => {
        console.log();
    };

    const handleSearchSelectFilter = (option) => {
        setSearchSelectFilter(option.value)
    };

    const handleSortByFilter = (option) => {
        setSortByOption(option.value)
    };

    // page scroll to add effect    
    const [isScrolled, setIsScrolled] = useState(false);
    // Function to handle scroll event
    const handleScroll = () => {
        if (window.scrollY > 50) { // Adjust the value based on when you want to add the class
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        // Add scroll event listener
        window.addEventListener('scroll', handleScroll);
        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const [setValue] = useState(null);

    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(15);
    const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(0);
    };

    const handleFilterSearchClick = (term) => {
        setFilteredTerm(term);
    }

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const handlePageSizeChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(0); // Reset to the first page on page size change
    };

    const sortedData = [...feedsData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    const filteredData = sortedData.filter(item => {
        // Check if the search term is in any column
        const searchLower = searchTerm.toLowerCase();
        return Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchLower)
        );
    });
    const paginatedData = filteredData.slice(
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );

    const handleTouchpointFilter = (touchpoint) => {
        setTouchpointFilter(touchpoint);
        localStorage.setItem("touchpointFilter", touchpoint);
    }
    const handleSobFilter = (sob) => {
        setSobFilter(sob);
        localStorage.setItem("sobFilter", sob);
    }

    const handleAllTouchpointSelect = (isSelected) => {
        setSobFilter('');
        setIsAllTouchpoints(isSelected);
    }

    const handleProjectFilter = (event) => {
        const selectedOption = event.target.value;
        setProjectFilter(selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.setItem('projectFilter', selectedOption === "Select Project" ? '' : selectedOption);
        localStorage.removeItem("sobFilter");
        localStorage.removeItem("touchpointFilter");
        window.location.reload();
    };

    const handleClearShowFilter = () => {
        setShowFilters('');
    };
    const handleClearSortByFilter = () => {
        setSortByOption('');
    };
    const handleClearSearchByFilter = () => {
        setSearchSelectFilter('');
        setSearchTerm('');
    };

    return (
        <>
            {IsLoading ? (
                <div className="screenLoader">
                    <ScreenLoader />
                </div>
            ) : noDataScreen ? (
                <h5 className="loadingScreen text-center">No data available</h5>
            ) : (
                <section className='container-fluid'>
                    <div className='Page-title d-flex align-items-center'>
                        <h3 className='mb-2'>Feeds</h3>
                        <div className='ms-2 mt-2'>
                            <div className="did-floating-label-content me-2 mt-2">
                                <select
                                    className="did-floating-select w-150px h-300"
                                    value={projectFilter}
                                    onChange={handleProjectFilter}
                                >
                                    {/* <option value="">Select Project</option> */}
                                    {projects.map((project) => (
                                        <option
                                            key={project.ProjectId}
                                            value={project.ProjectId}
                                        >
                                            {project.ProjectName}
                                        </option>
                                    ))}
                                </select>
                                <label className="did-floating-label">
                                    Project Filter
                                </label>
                            </div>
                        </div>
                        <div
                            className="did-floating-label-content mb-0">
                            <SingleSelectSobDropDown
                                onSobSelect={handleSobFilter}
                                onAllTouchpointSelect={handleAllTouchpointSelect}
                            />
                        </div>
                        <div
                            className={
                                (!isAllTouchPoints)
                                    ? "d-none did-floating-label-content mb-0"
                                    : "did-floating-label-content mb-0"
                            }>
                            <SingleSelectTouchpointDropdown
                                onTouchPointSelect={handleTouchpointFilter}
                            />
                        </div>
                        <div className='card-option ms-auto d-flex mt-1 pb-1'>
                            <div className="did-floating-label-content me-2 mb-0">
                                <select
                                    className="did-floating-select w-100px h-30"
                                    value={quickFilter}
                                    onChange={handleQuickFilter}
                                >
                                    <option value={""}>Select Filter</option>
                                    <option>FTD</option>
                                    <option>WTD</option>
                                    <option>MTD</option>
                                    <option>QTD</option>
                                    <option>YTD</option>
                                </select>
                                <label className="did-floating-label">
                                    Quick Filter
                                </label>
                            </div>
                            <div className='did-floating-label-content mb-0'>
                                <DateRangePickerComponent
                                    onRangeSelect={handleDateRangeFilter}
                                    quickFilter={quickFilter}
                                />
                            </div>
                        </div>
                    </div>
                    {/* page filter */}
                    <div className='row g-2'>
                        <div className='col-12 col-sm-5 col-md-4 col-lg-2 col-xl-2'>
                            <div className='card mb-2'>
                                <div className='card-body'>
                                    <div className='row'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            {/* <div className='did-floating-label-content  mb-3'>
                                                <SearchableSelect options={filteroptions} onSelect={handleSearchSelectFilter} />
                                                <label className="did-floating-label" style={{ marginTop: '-18px' }}>Search By</label>
                                            </div> */}
                                            <div className='did-floating-label-content mb-3.5'>
                                                <fieldset className='custom-fieldset pb-0'>
                                                <legend>Search By</legend>
                                                <div className='row'>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="Customer Name"
                                                            name="Customer Name"
                                                            value={'Customer Name'}
                                                            type='checkbox'
                                                            id='inline-Checkbox-1'
                                                            checked={searchSelectFilter == 'Customer Name' ? true : false}
                                                            onClick={(e) => setSearchSelectFilter(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="Phone Number"
                                                            name="Phone Number"
                                                            value={'Phone Number'}
                                                            type='checkbox'
                                                            id='inline-Checkbox-2'
                                                            checked={searchSelectFilter == 'Phone Number' ? true : false}
                                                            onClick={(e) => setSearchSelectFilter(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="Lab Number"
                                                            name="Lab Number"
                                                            value={'Lab Number'}
                                                            type='checkbox'
                                                            id='inline-Checkbox-2'
                                                            checked={searchSelectFilter == 'Lab Number' ? true : false}
                                                            onClick={(e) => setSearchSelectFilter(e.target.value)}
                                                        />
                                                    </div>
                                                    <input
                                                        type='text'
                                                        className='did-floating-input h-30 ms-2 mb-2'
                                                        style={{ fontSize: '10px', lineHeight: '30px', width: '90%' }}
                                                        onChange={(e) => setFilterSearchTerm(e.target.value)}
                                                        value={filterSearchTerm}
                                                        placeholder={`Search by ${searchSelectFilter}`}
                                                    />
                                                </div>
                                                <Button
                                                    type='button'
                                                    variant='primary'
                                                    onClick={() => handleFilterSearchClick(filterSearchTerm)}  // Correct usage here
                                                    // className='filterSearchTermButton'
                                                    size = 'sm'
                                                    className='mb-2 ms-1 me-1'
                                                >
                                                    Search
                                                    {/* <p className='filterSearchTermText'>Search</p> */}
                                                </Button>
                                                <Button variant='secondary' size='sm' className='mb-2' onClick={handleClearSearchByFilter} >Clear</Button>
                                            </fieldset>

                                                {/* <label className="did-floating-label">{`Search ${searchSelectFilter}`}</label> */}
                                            </div>
                                        </div>
                                        {/* <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3'>
                                        <div className='did-floating-label-content  mb-0'>
                                            <SearchableSelect options={issueoptions} onSelect={handleSelect} />
                                            <label className="did-floating-label" style={{ marginTop: '-18px' }}>Issues by</label>
                                        </div>
                                    </div> */}
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3'>
                                            <div className='did-floating-label-content  mb-0'>
                                                {/* <SearchableSelect options={filterDate} onSelect={handleSortByFilter} />
                                                <label className="did-floating-label" style={{ marginTop: '-18px' }}>Sort by</label> */}
                                                <fieldset className='custom-fieldset pb-0'>
                                                <legend>Short By</legend>
                                                <div className='row'>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="By response date newest first"
                                                            name="By response date newest first"
                                                            value={'DESC'}
                                                            type='checkbox'
                                                            id='inline-Checkbox-1'
                                                            checked={sortByOption == 'DESC' ? true : false}
                                                            onClick={(e) => setSortByOption(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="By response date oldest first"
                                                            name="By response date oldest first"
                                                            value={'ASC'}
                                                            type='checkbox'
                                                            id='inline-Checkbox-2'
                                                            checked={sortByOption == 'ASC' ? true : false}
                                                            onClick={(e) => setSortByOption(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <Button variant='secondary' size='sm' className='mb-2' onClick={handleClearSortByFilter} >Clear</Button>
                                            </fieldset>
                                            </div>
                                        </div>

                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3'>
                                            <fieldset className='custom-fieldset pb-0'>
                                                <legend>Show</legend>
                                                <div className='row'>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="Unread"
                                                            name="unread"
                                                            type='checkbox'
                                                            id='inline-Checkbox-1'
                                                            value={'unread'}
                                                            checked={showFilters == 'unread' ? true : false}
                                                            onClick={(e) => setShowFilters(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="Read"
                                                            name="read"
                                                            type='checkbox'
                                                            id='inline-Checkbox-1'
                                                            value={'read'}
                                                            checked={showFilters == 'read' ? true : false}
                                                            onClick={(e) => setShowFilters(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className='col-12 mb-1'>
                                                        <Form.Check
                                                            label="Only With Comments"
                                                            name="onlyWithComments"
                                                            type='checkbox'
                                                            id='inline-Checkbox-2'
                                                            checked={showFilters == 'onlyWithComments' ? true : false}
                                                            value={'onlyWithComments'}
                                                            onClick={(e) => setShowFilters(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='col-12 mb-1'>
                                                    <Form.Check
                                                        label="Without Comments"
                                                        name="withoutComments"
                                                        type='checkbox'
                                                        id='inline-Checkbox-3'
                                                        checked={showFilters == 'withoutComments' ? true : false}
                                                        value={'withoutComments'}
                                                        onClick={(e) => setShowFilters(e.target.value)}
                                                    />
                                                </div>
                                                <Button variant='secondary' size='sm' className='mb-2' onClick={handleClearShowFilter} >Clear</Button>
                                            </fieldset>
                                        </div>
                                        {/* <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3'>
                                        <fieldset className='custom-fieldset pb-0'>
                                            <legend>Status</legend>
                                            <div className='row'>
                                                <div className='col-12 mb-1'>
                                                    <Form.Check
                                                        label="Open"
                                                        name="group1"
                                                        type='checkbox'
                                                        id={`inline-Checkbox-5`}
                                                    />
                                                </div>
                                                <div className='col-12 mb-1'>
                                                    <Form.Check
                                                        label="In-progress"
                                                        name="group1"
                                                        type='checkbox'
                                                        id={`inline-Checkbox-6`}
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-12 mb-1'>
                                                <Form.Check
                                                    label="On-hold"
                                                    name="group1"
                                                    type='checkbox'
                                                    id={`inline-Checkbox-7`}
                                                />
                                            </div>
                                            <div className='col-12 mb-1'>
                                                <Form.Check
                                                    label="Closed"
                                                    name="group1"
                                                    type='checkbox'
                                                    id={`inline-Checkbox-8`}
                                                />
                                            </div>
                                            <div className='col-12 mb-1'>
                                                <Form.Check
                                                    label="Unassigned"
                                                    name="group1"
                                                    type='checkbox'
                                                    id={`inline-Checkbox-9`}
                                                />
                                            </div>
                                        </fieldset>

                                    </div> */}
                                        {/* <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3'>
                                        <div className='did-floating-label-content  mb-0'>
                                            <Autocomplete />
                                            <label className="did-floating-label" style={{ marginTop: '-18px' }}>Assign To</label>
                                        </div>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-sm-7 col-md-8 col-lg-10 col-xl-10'>
                            <div className='card mb-2'>
                                <div className='card-body p-2'>
                                    <div className='row g-2'>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='d-flex align-items-center'>
                                                <div>
                                                    <Button
                                                        variant={selectedFilters.includes('Promoters') ? "secondary" : "success"}
                                                        className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('Promoters') ? 'active' : 'inactive'}`}
                                                        onClick={() => handleFilterClick('Promoters')}
                                                    >
                                                        Promoters
                                                    </Button>
                                                    <Button
                                                        variant={selectedFilters.includes('Passives') ? "secondary" : "warning"}
                                                        className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('Passives') ? 'active' : 'inactive'}`}
                                                        onClick={() => handleFilterClick('Passives')}
                                                    >
                                                        Passives
                                                    </Button>
                                                    <Button
                                                        variant={selectedFilters.includes('Detractors') ? "secondary" : "danger"}
                                                        className={`btn-sm px-2 me-2 mb-2 ${selectedFilters.includes('Detractors') ? 'active' : 'inactive'}`}
                                                        onClick={() => handleFilterClick('Detractors')}
                                                    >
                                                        Detractors
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className='row'>
                                        <div className='col-12 col-sm-6 col-md-6'>
                                            <div className='d-flex align-items-center'>
                                                <label htmlFor="page-size" className='item-per-page'>Items per page : </label>
                                                <select className='form-control-sm did-floating-select h-30 w-50px px-2 ms-1 me-3' id="page-size" value={itemsPerPage} onChange={handlePageSizeChange}>
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={15}>15</option>
                                                    <option value={20}>20</option>
                                                </select>
                                                <input className='form-control-sm did-floating-input form-control h-30 w-max-200px'
                                                    type="text"
                                                    value={searchTerm}
                                                    onChange={handleSearchChange}
                                                    placeholder='Type here to search ...'
                                                />

                                            </div>

                                        </div>

                                        {/* <div className='col-12 col-sm-12 col-md-6 mb-1 mt-1 text-end'>
                                        <span style={{ fontSize: '12px' }}>
                                            Showing 1 to 2 of 2 entries
                                        </span>

                                    </div> */}
                                        <div className='col-12 col-sm-12 col-md-12 text-end mt-1 mb-1'>
                                            <p className='mb-1 me-1 paginationTotalCount'>Total items: {filteredData.length}</p>
                                            <ReactPaginate
                                                previousLabel={'Previous'}
                                                nextLabel={'Next'}
                                                breakLabel={'...'}
                                                pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                                                marginPagesDisplayed={2}
                                                pageRangeDisplayed={2}
                                                onPageChange={handlePageClick}
                                                containerClassName={'pagination'}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                        <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                            <div className='table-responsive custom-table-vertical-center'>
                                                <table className='table table-sm mb-0' style={{ tableLayout: 'fixed' }}>
                                                    <tbody>
                                                        {
                                                            paginatedData.map(item => {
                                                                return (
                                                                    <tr className={item.IsRead == 1? 'readTr feedsTr' : 'feedsTr'} key={item.id} onClick={() => handleFeedsTrClick(item.id, item.CustomerName)}>
                                                                        <td style={{ width: '85px' }}>
                                                                            <div className='speedometer-chart' style={{ width: '74px', margin: '0 auto' }}>
                                                                                <DashedCircleProgressBar
                                                                                    value={categoryScore[item.Rating]}
                                                                                    text={categoryScore[item.Rating]}
                                                                                    color={categoryColors[item.Rating]}
                                                                                    textColor={categoryColors[item.Rating]}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ width: '600px' }}>
                                                                            <strong>{item.CustomerName}</strong> | <strong>{item.TouchpointName}</strong> | <strong><GetTimeDifference date={item.RespondedOn} /></strong> | <p>{item.Suggestions}</p>
                                                                        </td>
                                                                        <td style={{ width: '100px' }}>
                                                                            {item.Status || "Open"}
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )}
        </>
    )
}

export default LiveFeeds;
